/**
 * Estrutura do menu principal da Home.
 *
 * A ordem reproduz o print `home-all-enabled_1.png`: duas colunas, lidas
 * em zigue-zague (col. esquerda / col. direita, linha a linha).
 *
 * `kind`:
 *   - 'action'   → botão simples, navega
 *   - 'dropdown' → botão com chip de seta e menu suspenso
 *   - 'search'   → o campo "Nº Processo:" com a lupa
 */
export const MENU_ITEMS = [
  {
    id: 'localizar', label: 'Localizar', kind: 'action', to: '/pesquisa', col: 1,
  },
  {
    id: 'numeroProcesso', label: 'Nº Processo:', kind: 'search', col: 2,
  },

  {
    id: 'consultaDinamica', label: 'Consulta dinâmica', kind: 'action', col: 1,
  },
  {
    id: 'manutencao',
    label: 'Manutenção',
    kind: 'dropdown',
    col: 2,
    views: [
      'Alterar Cliente Processo',
      'Alterar Comercial Processo',
      'Alterar Percentual de Recebimento',
    ],
  },

  {
    id: 'cadastros',
    label: 'Cadastros',
    kind: 'dropdown',
    col: 1,
    views: [
      'Parâmetros',
      'Usuários',
      'Filiais',
      'Ramos de Atividade',
      'Fases e Pastas',
      'Requisições',
      'Texto Padrão',
      'Títulos de Compromisso',
    ],
  },
  {
    id: 'minhasRequisicoes',
    label: 'Minhas requisições',
    kind: 'dropdown',
    col: 2,
    views: ['Requisições a serem atendidas', 'Requisições solicitadas', 'Requisições atendidas'],
  },

  {
    id: 'financeiro',
    label: 'Financeiro',
    kind: 'dropdown',
    col: 1,
    views: [
      'C/C de Comissionado',
      'C/C de Honorários',
      'Notas Fiscais',
      'Notas Fiscais de Devedores',
      'Recebimento de Clientes',
      'Recebimento de Devedores',
      'Pagamento Direto',
    ],
  },
  {
    id: 'analiseGerenciais',
    label: 'Análise gerenciais',
    kind: 'dropdown',
    col: 2,
    views: [
      'Rendimento Mensal Comercial',
      'Rendimento Mensal Negociadores',
      'Clientes em Débito',
      'Valores a Pagar pela ABE',
    ],
  },

  {
    id: 'estatisticaBorderos',
    label: 'Estatística de borderôs',
    kind: 'dropdown',
    col: 1,
    views: ['Controle de Entrada', 'Mapa de Borderôs', 'Resumo Mensal'],
  },
  {
    id: 'clientes',
    label: 'Clientes',
    kind: 'dropdown',
    col: 2,
    views: ['C/C de Cliente', 'Dados do Cliente'],
  },

  {
    id: 'ferramentas',
    label: 'Ferramentas',
    kind: 'dropdown',
    col: 1,
    views: ['Registrar Boletos', 'Validar Processos', 'Consultar Estatísticas', 'Gerar Arquivo WhatsApp'],
  },
  {
    id: 'borderos',
    label: 'Borderôs',
    kind: 'dropdown',
    col: 2,
    views: [
      'Importar',
      'Incluir',
      'Processar',
      'Visualizar Log',
      'Validar Borderô',
      'E-mail Entrada Borderô',
    ],
  },
];
